(function () {
    'use strict';

    angular.module("imApp").factory("postPlacesService", ['$ihttp', function ($ihttp) {
        let service = {
            getPostPlaces: function (parms) {
                return $ihttp.post({
                    method: 2206,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
